export function updateStudent(data) {
    return {
        type: "UPDATE_STUDENT",
        student: data
    };
}

export function updateTeacher(data) {
    return {
        type: "UPDATE_TEACHER",
        teacher: data
    };
}

export function updateSchoolAdmin(data) {
    return {
        type: "UPDATE_SCHOOL_ADMIN",
        schoolAdmin: data
    };
}

export function updateChartData(data,rules,xLabel,yLabel) {
    return {
        type: "UPDATE_CHART_DATA",
        chartData: data,
        chartRules:rules,
        xLabel:xLabel,
        yLabel:yLabel
    };
}

export function updateFunctionUpdateNote(data) {
    return {
        type: "UPDATE_FUNCTION_UPDATE_NOTE",
        updateNote: data
    };
}

export function updateAppName(data) {
    return {
        type: "UPDATE_APPNAME",
        appName: data
    };
}

export function selectClass(data) {
    return {
        type: "SELECT_CLASS",
        lastClass: data
    };
}

export function selectTeacher(data) {
    return {
        type: "SELECT_TEACHER",
        lastTeacher: data
    };
}

export function selectSchool(data) {
    return {
        type: "SELECT_SCHOOL",
        lastSchool: data
    };
}

export function selectStudentTab(data) {
    return {
        type: "SELECT_STUDENT_TAB",
        studentTab: data
    };
}

export function selectStudentScoreListTab(data) {
    return {
        type: "SELECT_SCORELIST_TAB",
        studentScoreListTab: data
    };
}

export function userLogout() {
    return {
        type: "LOGOUT"
    };
}

export function prepareChartData(data) {
    return async (dispatch) => {
        await Promise.all([
                dispatch(updateAppName(data.appName)),
                dispatch(updateStudent(data.student)),
                dispatch(updateFunctionUpdateNote(data.updateNote)),
                //dispatch(updateTeacher(data.teacher)),
                dispatch(updateChartData(data.chartData,data.chartRules,data.xLabel,data.yLabel))
            ]
        );
    }

}



// WEBPACK FOOTER //
// ./src/TeachersComponent/actions.js